import { atom, selectorFamily } from "recoil"
import { HonorsInfoModel } from "./typing"
import { achieveList } from "@/utils/api"
import { activityId } from "@/App"



export const medalRenewedState = atom<boolean>({
    key: 'medalRenewedState',
    default: true,
})

export const honorsInfoState = atom<HonorsInfoModel>({
  key: 'honorsInfoState',
  default: {
    achieve_list: [],
    reward_list: [],
  },
});

export const fetchHonorsInfoState = selectorFamily<HonorsInfoModel,string>({
    key: 'fetchHonorsInfoState',
    get: (id) => async ({ get }) => {
        const [e, r] = await achieveList<HonorsInfoModel>({ "aid": get(activityId), "_": id })
        if (r !== undefined) {
            return r.data
        }
        if (e !== undefined) {
            throw new Error(e.data.msg as string)
        }
        throw new Error('数据异常')
    },
})
